import React from "react";
import { storeService } from "@services";
import { DataTable } from "../Common";
import { DataTableColumn, DataTableProps } from "../Common/DataTable/DataTable";
import { useCurrentPageInfo, useModal } from "@hooks";
import { useSnackbar } from "notistack";
import { ServiceHelper } from "@modules";
import { QuantityReserve } from "@interfaces/QuantityReserve";

const QuantityReservesTable = () => {
    const { permission } = useCurrentPageInfo();
    const { handleOpenModal } = useModal();
    const { enqueueSnackbar } = useSnackbar();

    const handleEditClick: DataTableProps<QuantityReserve>["onEditClick"] = (rowData) => {
        if (rowData instanceof Array) return;
        handleOpenModal("EDIT_QUANTITY_RESERVE", { itemId: rowData.id, titleProps: rowData.id });
    };

    const handleDeleteClick = async (rowData: QuantityReserve | QuantityReserve[]) => {
        try {
            const ids = ServiceHelper.getIdsListFromRowDataObject(rowData);
            await storeService.deleteQuantityReserves(ids);
            enqueueSnackbar("Резервы остатков успешно удалены", {
                variant: "success",
            });
        } catch (err) {
            const message = err.response.data.error_tooltip;
            enqueueSnackbar(message || "Произошла ошибка при удалении резервов", {
                variant: "error",
            });
        }
    };

    const columns: DataTableColumn<QuantityReserve>[] = [
        {
            title: "#",
            field: "id",
            defaultSort: "asc",
            width: 100,
        },
        {
            title: "SKU",
            field: "sku",
            width: "auto",
        },
        {
            title: "Количество",
            field: "count",
            width: "auto",
        },
        {
            title: "Статус",
            field: "status",
            width: "auto",
        },
        {
            title: "Дата обновления",
            filtering: false,
            field: "updated_at",
            type: "datetime",
            width: "auto",
        },
    ];

    return (
        <DataTable<QuantityReserve>
            fetchFn={storeService.getQuantityReserves}
            columns={columns}
            displayField="sku"
            permission={permission}
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}
            onMassDeleteClick={handleDeleteClick}
            filtering
            sorting
            search
        />
    );
};

export default QuantityReservesTable;
